module.exports = __webpack_public_path__ + "img/3.6635df80.png";